import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../teacher/AuthContext';

const Profile = () => {
  const { currentUser, logout, loading } = useAuth() || {};
  console.log("Auth State:", { currentUser, loading });
  const navigate = useNavigate();
// 1. Handle the Loading State
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  // 1. Handle the "Not Logged In" state
  if (!currentUser) {
    return (
      <div className=" pt-24 flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="bg-red-50 p-8 rounded-2xl border border-red-100 shadow-sm max-w-md">
          <h2 className="text-2xl font-bold text-red-700 mb-2">Access Denied</h2>
          <p className="text-red-600 mb-6">Please log in to view your profile and manage your account.</p>
          <button 
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }
const handleLogout = async () => {
    try {
      await logout();
      navigate('/login'); // Ensure navigation happens after logout
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };
  // 2. Render the Profile
  return (
    <div className=" pt-24 max-w-4xl mx-auto py-12 px-6">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-extrabold text-gray-900">My Profile</h1>
        <button 
          onClick={handleLogout}
          className="text-sm font-medium text-gray-500 hover:text-red-600 transition-colors"
        >
          Sign Out
        </button>
      </div>

      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        {/* User Info Header */}
        <div className="p-8 border-b border-gray-100 bg-gray-50/50">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-gray-400">Email Address</label>
              <p className="text-gray-900 font-medium">{currentUser.email || "N/A" }</p>
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-gray-400">Account Type</label>
              <p className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mt-1 capitalize">
                {currentUser.role || "User"}
              </p>
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-gray-400">User ID</label>
              <p className="text-gray-500 font-mono text-sm">#{currentUser.id || '---'}</p>
            </div>
          </div>
        </div>

        {/* Dynamic Status Section for Tutors */}
       {currentUser.role?.toLowerCase() === 'tutor' && (
          <div className="p-8">
            <h3 className="text-lg font-bold text-gray-800 mb-4">Tutor Application Status</h3>
            
            {!currentUser.is_complete ? (
              /* State: Incomplete Profile */
              <div className="bg-amber-50 border border-amber-200 p-6 rounded-xl">
                <h4 className="text-amber-800 font-semibold mb-2">Finish your application</h4>
                <p className="text-amber-700 text-sm mb-4">You haven't submitted your profile for review yet. Finish the steps to start tutoring.</p>
                <button 
                  onClick={() => navigate('/tutoring/complete_profile')}
                  className="bg-amber-600 hover:bg-amber-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-all"
                >
                  Continue Application
                </button>
              </div>
            ) : !currentUser.approved ? (
              /* State: Pending Approval */
              <div className="bg-blue-50 border border-blue-200 p-6 rounded-xl">
                <h4 className="text-blue-800 font-semibold mb-2">Review in Progress</h4>
                <p className="text-blue-700 text-sm">Your profile is currently being reviewed by our quality management team. We will notify you once you are approved to set your availability.</p>
              </div>
            ) : (
              /* State: Approved & Active */
              <div className="space-y-6">
                <div className="bg-green-50 border border-green-200 p-6 rounded-xl">
                  <h4 className="text-green-800 font-semibold mb-1">Account Active</h4>
                  <p className="text-green-700 text-sm">Your profile is live! You can now manage your schedule and accept students.</p>
                </div>
                
                <div className="flex gap-4">
                  <button 
                    onClick={() => navigate('/tutoring/how')}
                    className="flex-1 py-3 px-4 bg-gray-900 hover:bg-black text-white rounded-xl font-medium transition-all text-center"
                  >
                    Update Availability
                  </button>
                  <button 
                    onClick={() => navigate('/dashboard')}
                    className="flex-1 py-3 px-4 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-xl font-medium transition-all text-center"
                  >
                    View Dashboard
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;